<template>
    <div>
        <popup title="Facility Documents" v-if="openPopup" @close="hidePopup()" @on-cancel-click="hidePopup()" 
        :displayPopup="openPopup" :showAddNewBtn="false" :showSaveBtn="false" >
            <div id="popupContent" style="height: 600px; overflow: auto; margin-bottom: 30px; min-height: 500px;"> 
                <div id="divDocumentTreeview" class="ehr-content-inner" > 
                    <document-treeview-vue-component key_id="0" web-service="GetFacilityDocumentsForTreeview" @closeTreeView="hidePopup()" >
                    </document-treeview-vue-component>         
                </div>
            </div>
        </popup>
    </div>
</template>

<script>
export default {
        name: "facility-documents-popup",
        props: {
          },
        data: function () {
            return {
                openPopup: false,
            };
        },
        mounted: function () {
            //mounted is an event in the lifecyle of a vue component
            },
        computed: {

        },
        watch: {

        },
        methods: {
            init: function () {
            },
            showPopup: function() {
                this.openPopup = true;
            },
            hidePopup: function() {
                this.openPopup = false;
            },
        }
    }
</script>